<template>
<div class="chapter">
<div class="inner_page">
<div id="Prologue.html" xml:lang="en-US">
<div class="Basic-Text-Frame-10">
<p class="ch"><a id="Anchor-1">Prologue</a></p><a id="Anchor-1">
<p class="indent">I, Fernanda Elena Maria Sobrano, am tell you this thing from my heart, how I find this man, Hawk Rivera, and ask for his help. My lady she not know what I do, but you will understand when I tell what happen.</p>
<p class="Basic-Paragraph-9">
</p></a></div><a id="Anchor-1">
</a></div><a id="Anchor-1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Prologue.vue?7260e366